module.exports = __webpack_public_path__ + "static/mlgImg-00eda61d76b66ba34d8e3b12e8af47fd.png";